import script from "./HrRecordsSection.vue?vue&type=script&setup=true&lang=js"
export * from "./HrRecordsSection.vue?vue&type=script&setup=true&lang=js"

import "./HrRecordsSection.vue?vue&type=style&index=0&id=80f3021c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-80f3021c"]])

export default __exports__